import {
    DockviewReact,
    DockviewReadyEvent,
} from 'dockview';
import React, { useState } from 'react';
import '@/assets/docview.css'
import AgentChat from '@/components/chat/agentchat';
import { ArrowLeft, Settings, Share2 } from 'lucide-react';
import { Link } from "react-router-dom";
import "@fortune-sheet/react/dist/index.css"
import ChatList from '../chatlist';
import { components, tabcomponents } from './components';



export const DocView: React.FC = (props: { theme?: string }) => {
    const [properties, setProperties] = useState<string>('');

    const onReady = (event: DockviewReadyEvent) => {
    
        const propertiespanel = event.api.addPanel({
            id: 'properties',
            component: 'properties',
            title: 'Properties',
            params: { properties, setProperties },
        });
        const documentpanel = event.api.addPanel({
            id: 'document',
            component: 'document',
            title: 'document',
            position: { referencePanel: propertiespanel },
        });
        const excelpanel = event.api.addPanel({
            id: 'excel',
            component: 'excel',
            title: 'excel',
            position: { referencePanel: propertiespanel },
        });
        const workspace = event.api.addPanel({
            id: 'workspace',
            component: 'workspace',
            title: 'Work space',
            position: { referencePanel: propertiespanel },
        });
    };




    return (
        <div className='flex flex-col h-full'>
            <div className='flex justify-between items-center p-4'>
                <div className='flex items-center'>
                    <Link to={`/`}>
                    <ArrowLeft className="h-4 w-4 mr-2" /></Link>
                    <h2 className='font-bold'>Agent: Chat with Me</h2>
                </div>
                <div className='flex space-x-2'>
                    <button className='p-2'>
                        <Settings className="h-4 w-4" />
                    </button>
                    <button className='p-2'>
                        <Share2 className="h-4 w-4" />
                    </button>
                </div>
            </div>
            <div className='flex-grow flex'>
                <div className='w-1/6 bg-zinc-50 p-2 pl-4'>
                    <ChatList/>
                </div>
                <div className='flex flex-row w-5/6'>
                    <div className='w-1/2 border border-gray-200 rounded-md'>
                        <AgentChat />
                    </div>
                <div className='w-1/2'>
                    <DockviewReact
                        components={components}
                        onReady={onReady}
                        className={`${props.theme || 'dockview-theme-replit'}`}
                        tabComponents={tabcomponents}
                    />
                </div>
                </div>
            </div>
        </div>
    );
};

export default DocView;
